// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"CardActivationHeader-module__subtitle___nturv"};